// @flow
import gql from 'graphql-tag';

export const GET_CURRENT_USER = gql`
  query user($uuid: ID!) {
    user(uuid: $uuid) {
      uuid
      id
      firstName
      lastName
      phone
      email
      isExternalUser
      isPayerUser
      twoFactorEnabled
      isPasswordSet
      phone
      chatDisplayName
      bio
      ssoOnly
      automaticReviewerAssignmentEnabled
      automaticCareTeamAssignmentEnabled
      capacity
      maximumAssignments
      languages {
        id
        code
      }
      role {
        id
        uuid
        name
        displayName
      }
      entities {
        id
        uuid
        name
        parentId
        automaticPatientAssignmentEnabled
        talkdeskEnabled
      }
      profilePicture {
        id
        location
      }
      profileVideos {
        id
        userProfileQuestionId
        location
      }
    }
  }
`;

export const GET_MY_TALKDESK_EMAIL = gql`
  query myTalkdeskEmail {
    myTalkdeskEmail
    myTalkdeskEmailOptions
  }
`;
